import React from 'react';
import PropTypes from 'prop-types';
import { useThemeTokensCallback } from '../ThemeProvider';
import LinkBase from './LinkBase';
import { variantProp } from '../utils';

/**
 * `TextButton` is a button that looks like a Link. It uses the same theming and variants as
 * Link but has the accessibility role of a `Button`. It should be used for actions that
 * take place on the current page, or for navigation within an app.
 */
import { jsx as _jsx } from "react/jsx-runtime";
const TextButton = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    onPress,
    children,
    variant,
    tokens,
    accessibilityRole = 'button',
    ...linkProps
  } = _ref;
  const getTokens = useThemeTokensCallback('Link', tokens, variant);
  return /*#__PURE__*/_jsx(LinkBase, {
    onPress: onPress,
    accessibilityRole: accessibilityRole,
    tokens: getTokens,
    ref: ref,
    ...linkProps,
    children: children
  });
});
TextButton.displayName = 'TextButton';
TextButton.propTypes = {
  ...LinkBase.propTypes,
  /** onPress function */
  onPress: PropTypes.func.isRequired,
  /** Children node that can be added */
  children: PropTypes.node.isRequired,
  variant: variantProp.propType,
  /** Accesibility role for TextButton */
  accessibilityRole: PropTypes.string
};
export default TextButton;